import * as types from "./actionTypes";
import * as paymentsApi from "../../_api/paymentsApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadAccountHistorySuccess(accountHistory) {
  return { type: types.LOAD_ACCOUNT_HISTORY_SUCCESS, accountHistory };
}

export function unloadAccountHistorySuccess(accountHistory) {
  return { type: types.UNLOAD_ACCOUNT_HISTORY_SUCCESS, accountHistory };
}

export function createPaymentSuccess(payment) {
  return { type: types.CREATE_PAYMENT_SUCCESS, payment };
}

export function loadInvoiceSuccess(invoice) {
  return { type: types.LOAD_INVOICE_SUCCESS, invoice };
}

export function resetInvoiceSuccess() {
  return { type: types.RESET_INVOICE_SUCCESS };
}

export function loadPaymentMethodSuccess(paymentMethod) {
  return { type: types.LOAD_PAYMENT_METHOD_SUCCESS, paymentMethod };
}

export function savePaymentMethodOptimistic(paymentMethod) {
  return { type: types.SAVE_PAYMENT_METHOD_OPTIMISTIC, paymentMethod };
}

export function deletePaymentMethodOptimistic(paymentMethod) {
  return { type: types.DELETE_PAYMENT_METHOD_OPTIMISTIC, paymentMethod };
}

export function deletePaymentMethodLastOptimistic(paymentMethod) {
  return { type: types.DELETE_PAYMENT_METHOD_LAST_OPTIMISTIC, paymentMethod };
}

export function createPaymentMethodSuccess(paymentMethod) {
  return { type: types.CREATE_PAYMENT_METHOD_SUCCESS, paymentMethod };
}

export function loadAccountHistory(ClientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getAccountHistory(ClientId)
      .then((accountHistory) => {
        if (accountHistory.length === 0) {
          dispatch(loadAccountHistorySuccess([{ CurrentState: "None" }]));
        } else {
          dispatch(loadAccountHistorySuccess(accountHistory));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function unloadAccountHistory() {
  return function (dispatch) {
    dispatch(unloadAccountHistorySuccess([{ CurrentState: "Reset" }]));
  };
}

export function createPayment(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .createPayment(params)
      .then((payment) => {
        dispatch(createPaymentSuccess(payment));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function getInvoiceEstimateSummary(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getInvoiceEstimateSummary(params)
      .then((returnData) => {
        return returnData;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function createAsanaTicket(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .asanaTicket(params)
      .then(() => {
        return null;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function validateSecurePayment(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .validateSecurePayment(params)
      .then((returnData) => {
        return returnData;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function securePayment(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .securePayment(params)
      .then((returnData) => {
        return returnData;
      })
      .catch((error) => {
        console.error('securepayment api err:', error)
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function createInvoicePayment(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .createInvoicePayment(params)
      .then((invoicePayment) => {
        return invoicePayment;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadInvoice(invoiceId, clientId, jurisdictionID) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getInvoice(invoiceId, clientId, jurisdictionID)
      .then((invoice) => {
        dispatch(loadInvoiceSuccess(invoice));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetInvoice() {
  return function (dispatch) {
    dispatch(resetInvoiceSuccess());
  };
}

export function loadPaymentMethod(ClientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .getPaymentMethod(ClientId)
      .then((paymentMethod) => {
        if (paymentMethod.length === 0) {
          dispatch(loadPaymentMethodSuccess([{ CurrentState: "None" }]));
        } else {
          //Remove any deleted cards if they got through
          const filteredPaymentMethod = paymentMethod.filter(
            (x) =>
              x.CreditCardStatus !== "Deleted" &&
              x.CreditCardStatus !== "Inactive"
          );
          if (filteredPaymentMethod.length === 0) {
            dispatch(loadPaymentMethodSuccess([{ CurrentState: "None" }]));
          } else {
            dispatch(loadPaymentMethodSuccess(filteredPaymentMethod));
          }
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function deletePaymentMethod(id, params, cardCount) {
  return function (dispatch) {
    if (cardCount === 1) {
      return paymentsApi.updatePaymentMethod(id, params).then(() => {
        dispatch(deletePaymentMethodLastOptimistic([{ CurrentState: "None" }]));
      });
    } else {
      dispatch(deletePaymentMethodOptimistic(params));
      dispatch(beginApiCall());
      return paymentsApi.updatePaymentMethod(id, params);
    }
  };
}

export function savePaymentMethod(id, params) {
  return function (dispatch) {
    dispatch(savePaymentMethodOptimistic(params));
    dispatch(beginApiCall());
    return paymentsApi.updatePaymentMethod(id, params);
  };
}

export function createPaymentMethod(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return paymentsApi
      .createPaymentMethod(params)
      .then((paymentMethod) => {
        dispatch(createPaymentMethodSuccess(paymentMethod));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
